import React from 'react'
import {
    Alert,
    Box,
    TableHead,
    TableRow,
    TableCell,
    Checkbox,
    Menu,
    MenuItem,
} from '@mui/material'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faTrash,
    faFileExport,
    faBell,
    faBellSlash,
    faFolder,
    faSort,
    faSortUp,
    faSortDown,
    faTimes,
    faBars,
} from '@fortawesome/free-solid-svg-icons'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import MultiContentDossierSubscribe from '../../DefDossierToolbar/MultiContentDossierSubscribe'
import MultiContentDossierArchive from '../../DefDossierToolbar/MultiContentDossierArchive'
import ContentDossierExport from '../../DefDossierToolbar/ContentDossierExport'
import MultiContentDossierDelete from '../../DefDossierToolbar/MultiContentDossierDelete'
import AdminQuickEditMenu from '@/Components/Elements/AdminQuickEditMenu'
import ShowEntries from '@/Components/Elements/ShowEntries'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

interface ListItem {
    id: string
    view?: string
    archived?: boolean
    def_dossier_def_field?: { id: string }
    settings?: { dossier_data: string }
}

interface Dossier {
    id: string
    archived?: boolean
}

interface DossierTableHeadProps {
    results: any
    actionBtns: any[]
    selected: string[]
    dossiers: any[]
    sort: any[]
    showActionModal: string
    limit: number
    pager: any
    subscriptions: any
    mode: string
    defDossierId: string
    showEmail?: boolean
    multiAdd?: React.ReactNode
    addDossier?: React.ReactNode
    filterDossier?: React.ReactNode
    kedo: any

    checkAll: (e: React.ChangeEvent<HTMLInputElement>) => void
    applySort: (e: any, item: any, order: 'ASC' | 'DESC') => void
    clearSort: (e: any, item: any) => void
    handleEntriesChange: (val: number) => void

    fetchItems: () => void
    onDeleteSuccess: () => void
    getSearchFilter: any

    setShowActionModal: (modal: string) => void
    setShowAllExportModal: (modal: string) => void

    isAllowedDd: (action: string) => boolean
    isSortable: (item: any) => boolean
    isCustomActionButton: (item: any) => boolean
    canBeArchived: () => boolean
}

const DefDossierListTableHead: React.FC<DossierTableHeadProps> = ({
    results,
    actionBtns,
    selected,
    dossiers,
    sort,
    showActionModal,
    limit,
    pager,
    subscriptions,
    mode,
    defDossierId,
    showEmail,
    multiAdd,
    addDossier,
    filterDossier,
    kedo,

    checkAll,
    applySort,
    clearSort,
    handleEntriesChange,

    fetchItems,
    onDeleteSuccess,
    getSearchFilter,

    setShowActionModal,
    setShowAllExportModal,

    isAllowedDd,
    isSortable,
    isCustomActionButton,
    canBeArchived,
}) => {
    if (!results || !results.items) return null

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = (action?: string) => {
        if (action && selectedDossiers.length <= 0) {
            alert(kedo.t('Select dossiers first'))
            setAnchorEl(null)
            return
        }
        if (action) setShowActionModal(action)
        setAnchorEl(null)
    }

    const ddArchiveable = canBeArchived()

    const listItems = results.items.filter(
        (item) => item.view === 'list' && !isCustomActionButton(item)
    )

    const allDossiers = results.dossiers
    const selectedItems = selected

    const selectedDossiers = allDossiers.filter((item) =>
        selectedItems.find((selectedId) => selectedId === item.id)
    )

    const archivedDossiers =
        ddArchiveable && selectedDossiers.find((item) => item.archived === true)

    const dearchivedDossiers =
        ddArchiveable &&
        selectedDossiers.find((item) => item.archived === false)

    const extraColumns = actionBtns.length > 0 ? 4 : 3

    return (
        <TableHead>
            <TableRow
                sx={{
                    '& td, & th': {
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    },
                }}
            >
                <TableCell colSpan={listItems.length + extraColumns}>
                    {selectedItems.length > 0 && (
                        <Box>
                            {isAllowedDd('delete') && (
                                <StyledButton
                                    variant="outlined"
                                    invert
                                    color="error"
                                    sx={{
                                        '&  svg ': {
                                            mr: 1,
                                        },
                                    }}
                                    onClick={(event) => {
                                        event.preventDefault()

                                        if (selectedDossiers.length <= 0) {
                                            alert(
                                                kedo.t('Select dossiers first')
                                            )
                                            return
                                        }

                                        setShowActionModal('delete')
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                    <span>{kedo.t('Delete')}</span>
                                </StyledButton>
                            )}

                            <StyledButton
                                variant="outlined"
                                invert
                                color="secondary"
                                sx={{
                                    '&  svg ': {
                                        mr: 1,
                                    },
                                }}
                                onClick={(event) => {
                                    event.preventDefault()

                                    if (selectedDossiers.length <= 0) {
                                        alert(kedo.t('Select dossiers first'))
                                        return
                                    }

                                    setShowActionModal('export')
                                }}
                            >
                                <FontAwesomeIcon icon={faFileExport} />
                                {kedo.t('Export')}
                            </StyledButton>

                            <StyledButton
                                variant="outlined"
                                invert
                                color="secondary"
                                endIcon={
                                    <FontAwesomeIcon
                                        icon={faCaretDown}
                                        size="sm"
                                    />
                                }
                                sx={{
                                    '& .MuiButton-endIcon svg ': {
                                        fontSize: '16px',
                                    },
                                }}
                                onClick={handleMenuOpen}
                                startIcon={<FontAwesomeIcon icon={faBars} />}
                            >
                                {kedo.t('More actions')}
                            </StyledButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={() => handleMenuClose()}
                                sx={{
                                    '&  svg ': {
                                        mr: 1.5,
                                    },
                                }}
                            >
                                <MenuItem
                                    onClick={() => handleMenuClose('subscribe')}
                                >
                                    <FontAwesomeIcon icon={faBell} />
                                    {kedo.t('Subscription')}
                                </MenuItem>
                                <MenuItem
                                    onClick={() =>
                                        handleMenuClose('stopsubscription')
                                    }
                                >
                                    <FontAwesomeIcon icon={faBellSlash} />
                                    {kedo.t('Stop subscription')}
                                </MenuItem>
                                {dearchivedDossiers &&
                                    isAllowedDd('archive') && (
                                        <MenuItem
                                            onClick={() =>
                                                handleMenuClose('archive')
                                            }
                                        >
                                            <FontAwesomeIcon icon={faFolder} />
                                            {kedo.t('Archive')}
                                        </MenuItem>
                                    )}
                                {archivedDossiers && isAllowedDd('archive') && (
                                    <MenuItem
                                        onClick={() =>
                                            handleMenuClose('dearchive')
                                        }
                                    >
                                        <FontAwesomeIcon icon={faFolder} />
                                        {kedo.t('Dearchive')}
                                    </MenuItem>
                                )}
                            </Menu>
                        </Box>
                    )}

                    {showActionModal === 'delete' && (
                        <MultiContentDossierDelete
                            kedo={kedo}
                            showModal={true}
                            size="sm"
                            items={selectedItems}
                            mode={mode}
                            onCancel={() => setShowActionModal('')}
                            onClose={() => {
                                setShowActionModal('')
                                onDeleteSuccess()
                            }}
                        />
                    )}

                    {showActionModal === 'export' &&
                        kedo
                            .env()
                            .isAllowedDefDossier(
                                'export',
                                defDossierId,
                                kedo.user()
                            ) && (
                            <ContentDossierExport
                                showModal={true}
                                defDossierId={defDossierId}
                                filter={getSearchFilter}
                                size="sm"
                                kedo={kedo}
                                selected={selected}
                                mode={mode}
                                onCancel={() => setShowActionModal('')}
                                onClose={() => {
                                    fetchItems()
                                    setShowActionModal('')
                                }}
                            />
                        )}

                    {(showActionModal === 'subscribe' ||
                        showActionModal === 'stopsubscription') && (
                        <MultiContentDossierSubscribe
                            kedo={kedo}
                            showModal={true}
                            subscriptions={subscriptions}
                            items={selected}
                            mode={mode}
                            showActionModal={showActionModal}
                            onClose={() => {
                                fetchItems()
                                setShowActionModal('')
                            }}
                        />
                    )}

                    {(showActionModal === 'archive' ||
                        showActionModal === 'dearchive') && (
                        <MultiContentDossierArchive
                            kedo={kedo}
                            showModal={true}
                            archived={showActionModal === 'archive'}
                            checked={selected}
                            mode={mode}
                            onClose={() => {
                                fetchItems()
                                setShowActionModal('')
                            }}
                        />
                    )}

                    <Box
                        display="flex"
                        justifyContent={
                            selected.length ? 'space-between' : 'flex-end'
                        }
                        alignItems="center"
                    >
                        {multiAdd ? multiAdd : null}
                        &nbsp;
                        {mode === 'embeddedList' && addDossier}
                        &nbsp;
                        {mode === 'embeddedList' && filterDossier}
                        &nbsp;
                        {allDossiers.length > 0 &&
                        selectedItems.length <= 0 &&
                        kedo
                            .env()
                            .isAllowedDefDossier(
                                'export',
                                defDossierId,
                                kedo.user()
                            ) ? (
                            <ContentDossierExport
                                defDossierId={defDossierId}
                                kedo={kedo}
                                onClose={() => setShowAllExportModal(false)}
                                filter={getSearchFilter}
                                mode={'all'}
                            />
                        ) : null}
                        {allDossiers.length > 0 &&
                            selectedItems.length <= 0 && (
                                <ShowEntries
                                    pager={pager}
                                    value={limit}
                                    onChange={handleEntriesChange}
                                />
                            )}
                        &nbsp;
                    </Box>
                </TableCell>
            </TableRow>

            {!results || !results.dossiers || results.dossiers.length <= 0 ? (
                <Alert severity={'info'} sx={{ margin: '0 17px' }}>
                    &nbsp; {kedo.t('No items found')}
                </Alert>
            ) : (
                <TableRow
                    sx={{
                        '& td, & th': {
                            borderBottom: '1px solid',
                            borderTop: '1px solid',
                            borderColor: 'divider',
                        },
                    }}
                >
                    <TableCell style={{ width: '3%' }}>
                        {allDossiers.length > 0 ? (
                            <Checkbox
                                checked={selected.length === dossiers.length}
                                onChange={(e) => checkAll(e)}
                                size="small"
                                sx={{ p: 0, mr: 0 }}
                            />
                        ) : null}
                    </TableCell>
                    {showEmail === true ? <TableCell /> : null}
                    <TableCell style={{ textAlign: 'center' }}>
                        <FontAwesomeIcon icon={faBell} />
                    </TableCell>
                    {listItems.map((listItem) => {
                        const sortable = isSortable(listItem)
                        let sortItem = null
                        if (
                            listItem.def_dossier_def_field &&
                            listItem.def_dossier_def_field.id
                        ) {
                            sortItem = sort.find(
                                (itList) =>
                                    itList.item.def_dossier_def_field &&
                                    itList.item.def_dossier_def_field.id ===
                                        listItem.def_dossier_def_field.id
                            )
                        } else if (
                            listItem.settings &&
                            listItem.settings.dossier_data
                        ) {
                            sortItem = sort.find(
                                (itList) =>
                                    itList.item.settings &&
                                    listItem.settings.dossier_data ===
                                        itList.item.settings.dossier_data
                            )
                        }

                        //Item is not sortable
                        if (!sortable) {
                            return (
                                <TableCell
                                    data-ddiid={listItem.id}
                                    key={listItem.id}
                                >
                                    {kedo
                                        .env()
                                        .translateItem(listItem, 'displayitem')}
                                    <AdminQuickEditMenu
                                        className={'list-admin-edit-buttons'}
                                        kedo={kedo}
                                        item={listItem}
                                    />
                                </TableCell>
                            )
                        }

                        //Item is sortable
                        return (
                            <TableCell
                                data-ddiid={listItem.id}
                                key={listItem.id}
                            >
                                <span
                                    onClick={(e) =>
                                        applySort(
                                            e,
                                            listItem,
                                            sortItem && sortItem.order === 'ASC'
                                                ? 'DESC'
                                                : 'ASC'
                                        )
                                    }
                                    style={{ cursor: 'pointer' }}
                                >
                                    {kedo
                                        .env()
                                        .translateItem(
                                            listItem,
                                            'displayitem'
                                        )}{' '}
                                    &nbsp;
                                    {sortItem ? (
                                        <FontAwesomeIcon
                                            icon={
                                                sortItem.order === 'ASC'
                                                    ? faSortUp
                                                    : faSortDown
                                            }
                                        />
                                    ) : (
                                        <Box
                                            component="span"
                                            sx={{ color: 'text.secondary' }}
                                        >
                                            <FontAwesomeIcon icon={faSort} />
                                        </Box>
                                    )}
                                    &nbsp;&nbsp;
                                </span>
                                {sortItem ? (
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        onClick={(e) => clearSort(e, listItem)}
                                        size={'sm'}
                                        style={{ cursor: 'pointer' }}
                                    />
                                ) : null}
                                <AdminQuickEditMenu
                                    className={'list-admin-edit-buttons'}
                                    kedo={kedo}
                                    item={listItem}
                                />
                            </TableCell>
                        )
                    })}
                    {actionBtns.length > 0 ? (
                        <TableCell>{kedo.t('Actions')}</TableCell>
                    ) : null}
                    <TableCell />
                </TableRow>
            )}
        </TableHead>
    )
}

export default DefDossierListTableHead
